import { UsersService } from './../../../shared/services/common/users.service';
import { DisplayNotificationService } from './../../../shared/services/common/notification.service';
import { HttpErrorResponse } from '@angular/common/http';
import { AdjustmentService } from './../../../shared/services/adjustments/adjustment.service';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { State, process } from '@progress/kendo-data-query';
import { RowArgs, SelectableSettings } from '@progress/kendo-angular-grid';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/shared/services/auth/auth.service';
import { Utility } from 'src/app/shared/utility';

@Component({
  selector: 'app-rejected-adjustment-records',
  templateUrl: './rejected-adjustment-records.component.html',
  styleUrls: ['./rejected-adjustment-records.component.css']
})
export class RejectedAdjustmentRecordsComponent implements OnInit {

  gridState: State = {
    sort: [],
    take: 10,
    skip: 0
  };
  filter: any;
  operators: any;
  isMoveDisabled = true;
  isDeleteDisabled = true;
  textAreaValue = '';
  adjCommentDialog: boolean;
  inputData: { userInfo: any; };
  adjInputData: { userInfo: any, adjType: string };
  selectedData = [];
  gridData = [];
  isActionBtnDisabled: boolean;
  adjDeleteDialog: boolean;
  adjMoveDialog: boolean;
  loading: boolean;
  filteredNotSubmittedAdj: any;
  selectedAdjValue: any;
  isRowSelected: (e: RowArgs) => boolean;
  defaultNotsubmittedAdj: any;
  newNotSubmittedAdj: any;
  isClicked = false;
  adjRecord: any;
  reasonCodesList: any;
  defaultItem: { id: any } = {
    id: 'New Adjustment'
  };
  selectableSettings: SelectableSettings = {
    enabled: true, checkboxOnly: true, mode: 'multiple'
  };

  @Input() set accessOperators(operator: any) {
    if (operator) {
      this.operators = operator;
    }
  }
  @Output() loadCreateReport: EventEmitter<any> = new EventEmitter();

  constructor(
    private router: Router,
    private usersService: UsersService,
    private authService: AuthService,
    private adjustmentService: AdjustmentService,
    private notificationService: DisplayNotificationService
  ) { }

  ngOnInit() {
    this.inputData = {
      userInfo: this.usersService.UserInfo()
    };
    this.notificationService.setUpLoading(true);
    this.getAdjustmentLocSys();
    this.getRejectedAdjRecords();
    this.getAdjustmentRecords();
    this.isRowSelected = (e: RowArgs) => this.selectedData.indexOf(e.dataItem) >= 0;
  }

  getAdjustmentLocSys() {
    this.adjustmentService.getAdjustmentInputs(this.inputData).subscribe(response => {
      if (response && response.success) {
        const newArray = response.reasonCodes.map(item => ({
          ...item,
          reasonCode: item.id + '-' + item.reason
        }));
        this.reasonCodesList = newArray;
      } else {
        this.notificationService.setErrorNotification();
        this.notificationService.setUpLoading(false);
      }
    },
      (error: HttpErrorResponse) => {
        console.log(error);
        this.notificationService.setUpLoading(false);
        this.notificationService.setErrorNotification();
      });
  }

  getRejectedAdjRecords() {
    this.notificationService.setUpLoading(true);
    this.selectedData = [];
    this.adjustmentService.getRejectedRecords(this.inputData).subscribe(response => {
      if (response && response.statusCode === 200 && response.adjustmentRecords) {
        response.adjustmentRecords.forEach((element: any) => {
          element.formatAmount = Utility.checkNegativeAmount(element.employeeContribution);
          element.lastFourSSN = element.ssn.substr(5);
        });
        this.gridState.skip === 0;
        this.gridData = response.adjustmentRecords;
      } else if (response && response.statusCode === 204) {
        this.gridData = [];
      } else if (response && response.StatusCode === 403) {
        this.router.navigate(['/forbidden']);
      } else {
        this.notificationService.setErrorNotification();
      }
      this.notificationService.setUpLoading(false);
    },
      (error: HttpErrorResponse) => {
        console.log(error);
        this.notificationService.setUpLoading(false);
        this.notificationService.setErrorNotification();
      })
  }

  getAdjustmentRecords() {
    this.newNotSubmittedAdj = [];
    this.filteredNotSubmittedAdj = [];
    this.inputData['adjType'] = 'NotSubmitted';
    this.adjustmentService.getPayrollAdjRecords(this.inputData).subscribe((data: any) => {
      if (data && data.statusCode === 200 && data.adjustments) {
        const orgValue = JSON.parse(this.authService.decryptText(Utility.removeQuotes(sessionStorage.getItem('current_user'))));
        const notSubmittedAdj = data.adjustments.filter(ele => ele.creatorId === Number(orgValue.Id));
        const arrangedAdjData = notSubmittedAdj.sort((a, b) => a.Id - b.Id);
        this.filteredNotSubmittedAdj = arrangedAdjData
        this.newNotSubmittedAdj = arrangedAdjData.slice();
        this.defaultNotsubmittedAdj = this.defaultItem;
      } else if (data && data.statusCode === 204) {
        this.filteredNotSubmittedAdj = [];
      } else {
        this.notificationService.setErrorNotification();
      }
    },
      (err: HttpErrorResponse) => {
        console.log(err);
        this.notificationService.setUpLoading(false);
        this.notificationService.setErrorNotification();
      })
  }

  handleFilter(value: any) {
    this.filteredNotSubmittedAdj = value ? this.newNotSubmittedAdj.filter((s: any) => s.id.toString().indexOf(value.toString()) !== -1)
      : this.newNotSubmittedAdj.slice();
  }

  openRecord(record: any, isClicked: boolean) {
    this.isClicked = isClicked;
    const reasonCodeArray = record.reasonCodes && record.reasonCodes.split(',').map(code => code.trim());
    const array2Integers = reasonCodeArray?.map(item => parseInt(item, 10));
    const filteredRecords = this.reasonCodesList.filter(item => array2Integers?.includes(item.id));
    this.adjRecord = record;
    this.adjRecord.reasonCodeArray = filteredRecords;
  }

  isDialogClosed(isClosed: boolean) {
    this.isClicked = isClosed;
  }

  openCommentDialog(dataItem: any) {
    this.textAreaValue = dataItem.comments ? dataItem.comments : '';
    this.adjCommentDialog = true;
  }

  onSelectionChange(event: any) {
    if (event.selectedRows.length > 0) {
      this.selectedData.push(event.selectedRows[0].dataItem);
    } else if (event.deselectedRows.length > 0) {
      const index = this.selectedData.indexOf(event.deselectedRows[0].dataItem);
      this.selectedData.splice(index, 1);
    }
    this.isRowSelected = (e: RowArgs) => this.selectedData.indexOf(e.dataItem) >= 0;
    this.isActionBtnDisabled = this.selectedData && this.selectedData.length > 0;

  }

  closeCommentDialog() {
    this.adjCommentDialog = false;
  }

  moveRejectedAdjustments() {
    this.adjMoveDialog = true;
  }

  moveAdj(status: any): void {
    if (status === 'yes') {
      this.loading = true;
      const allAdjRecordIds = this.selectedData.map(x => x.id).join(",")
      const selectedAdj = this.defaultNotsubmittedAdj.id === 'New Adjustment' ? 0 : this.defaultNotsubmittedAdj.id;
      const inputData = {
        userInfo: this.usersService.UserInfo(),
        rejectedRecordIDs: allAdjRecordIds,
        adjustmentID: selectedAdj
      };
      this.adjustmentService.moveRejectedRecords(inputData).subscribe(response => {
        if (response && response.statusCode === 200) {
          this.notificationService.setUpNotification({ success: true, message: response.message });
          this.selectedData = [];
          this.loadCreateReport.emit({adjId: response.id, isRejectedRecord: true});
        } else {
          this.notificationService.setErrorNotification(response.message);
        }
        this.loading = false;
        this.adjMoveDialog = false;
        this.isActionBtnDisabled = this.selectedData && this.selectedData.length > 0;
        this.defaultNotsubmittedAdj = this.defaultItem;
      },
        (error: HttpErrorResponse) => {
          console.log(error);
          this.loading = false;
          this.notificationService.setUpLoading(false);
          this.notificationService.setErrorNotification();
        });
    } else {
      this.adjMoveDialog = false;
    }
  }

  deleteRejectedAdjustments() {
    this.adjDeleteDialog = true;

  }

  deleteAdj(status: any): void {
    if (status === 'yes') {
      this.loading = true;
      const allAdjRecordIds = this.selectedData.map(x => x.id).join(",")
      const inputData = {
        userInfo: this.usersService.UserInfo(),
        rejectedRecordIDs: allAdjRecordIds
      };
      this.adjustmentService.deleteRejectedRecords(inputData).subscribe(response => {
        if (response && response.statusCode === 200) {
          this.getRejectedAdjRecords();
          this.notificationService.setUpNotification({ success: true, message: response.message });
        } else {
          this.notificationService.setErrorNotification(response.message);
        }
        this.loading = false;
        this.adjDeleteDialog = false;
        this.isActionBtnDisabled = this.selectedData && this.selectedData.length > 0;
      },
        (error: HttpErrorResponse) => {
          console.log(error);
          this.loading = false;
          this.notificationService.setUpLoading(false);
          this.notificationService.setErrorNotification();
        });
    } else {
      this.adjDeleteDialog = false;
    }
  }

}
